module.exports = __webpack_public_path__ + "media/images/beate_ningaloo-67a64590c7a05ee6ad7340c9db68daa9.png";